var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgApplicationsSolidsvg = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 1024,
  height: 1024,
  viewBox: "0 0 36 36"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M4 4h6v6H4z",
  className: "clr-i-solid clr-i-solid-path-1"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M4 15h6v6H4z",
  className: "clr-i-solid clr-i-solid-path-2"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M4 26h6v6H4z",
  className: "clr-i-solid clr-i-solid-path-3"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M15 4h6v6h-6z",
  className: "clr-i-solid clr-i-solid-path-4"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M15 15h6v6h-6z",
  className: "clr-i-solid clr-i-solid-path-5"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M15 26h6v6h-6z",
  className: "clr-i-solid clr-i-solid-path-6"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M26 4h6v6h-6z",
  className: "clr-i-solid clr-i-solid-path-7"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M26 15h6v6h-6z",
  className: "clr-i-solid clr-i-solid-path-8"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M26 26h6v6h-6z",
  className: "clr-i-solid clr-i-solid-path-9"
})), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h36v36H0z"
})));
export { SvgApplicationsSolidsvg as ReactComponent };
export default __webpack_public_path__ + "static/media/applications-solid.svg.3b225d757f162b058623f3c4202e6a32.svg";